module.exports = __webpack_public_path__ + "img/IMG_20181212_103617_thumb.8e948b6b.jpg";